module.exports = __webpack_public_path__ + "static/img/2bg_1.d382cac.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/2bg_1.png
// module id = 672
// module chunks = 1